import React, { useEffect, useState } from "react";
import "./mailbox_styles/rightpage.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faPrint,
  faTrash,
  faEllipsisVertical,
  faB,
  faItalic,
  faUnderline,
  faPaperclip,
  faImage,
  faPaperPlane
} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { emailsRef } from "../../firebase";
import { fetchUserProfileData } from "../../App";
import LoadingPage from "../LoadingPage";
import userLogo from "../../images/user.jpg";
import { serverTimestamp } from "../../firebase";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import swal2 from "sweetalert2";

export const formatDate = (timestamp) => {
  if (!timestamp) {
    return '';
  }
  const date = timestamp.toDate();
  const now = new Date();
  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();
  const dateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  const timeOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };
  const dateString = isToday
    ? 'Today, ' + date.toLocaleDateString(undefined, dateOptions)
    : date.toLocaleDateString(undefined, {
      ...dateOptions,
      day: 'numeric',
    });
  const timeString = date.toLocaleTimeString(undefined, timeOptions);
  return dateString + ', ' + timeString;
};


const fetchData = async (openMailIDocId, currentMailOption) => {
  const docRef = emailsRef.doc(openMailIDocId);
  const docSnapshot = await docRef.get();
  if (docSnapshot.exists) {
    const data = docSnapshot.data();
    const fetchedUsersData = await fetchUserProfileData(currentMailOption === 'inbox' ? data.from_email : currentMailOption === 'sent-mails' ? data.to : data.from_email);
    return [data, fetchedUsersData];
  }
};

const Rightpage = () => {
  const usersData = useSelector((state) => state.userData);
  const [mailCardState, setMailCardState] = useState("");
  const [emailData, setEmailData] = useState({});
  const [fetchedUsersDataState, setFetchedUsersDataState] = useState({});
  const [replyEmailData, setReplyEmailData] = useState({
    to: "",
    subject: "",
    email_body: "",
  })

  const location = useLocation();
  const currentPath = location.pathname;
  const currentMailOption = currentPath.split("/")[2];
  const openMailIDocId = currentPath.split("/")[3];

  const handleMailCardClick = () => {
    if (mailCardState === "") {
      setMailCardState("closeMailCard");
    } else {
      setMailCardState("");
    }
  }

  useEffect(() => {
    fetchData(openMailIDocId, currentMailOption)
      .then(([data, fetchedUsersData]) => {
        setEmailData(data);
        // console.log(data);
        setFetchedUsersDataState(fetchedUsersData);
        setReplyEmailData(
          {
            ...replyEmailData,
            to: data.from_email,
            subject: data.subject,
            from_email: usersData.email,
            timestamp: serverTimestamp,
            opened: false
          });
      })
      .catch(error => console.log(error));
    // eslint-disable-next-line
  }, [openMailIDocId, emailData.from_email]);


  // console.log(emailData);
  // console.log(fetchedUsersDataState);

  const inputEvent = (event) => {
    let { name, value } = event.target;
    setReplyEmailData((preValue) => {
      return {
        ...preValue,
        [name]: value,
      }
    })
  }

  const handleReplyEmailSend = async (event) => {
    event.preventDefault();
    if (replyEmailData.to === "" || replyEmailData.subject === "" || replyEmailData.from_email === "") {
      return swal("Server Error", "Something went wrong!!", "error");
    }
    if (replyEmailData.email_body === "") {
      return swal("Warning", "Please specify email body.", "warning");
    }
    else {
      // console.log(replyEmailData);
      await emailsRef.add({
        ...replyEmailData,
        from_email: usersData.email,
        timestamp: serverTimestamp,
        opened: false
      })
        .then(() => {
          swal2.fire({
            icon: 'success',
            title: `Email Sent !`,
            showConfirmButton: false,
            timer: 1500
          })
        })
        .catch((error) => {
          swal("Error", "Something went wrong !", "error");
        });
    }
    setReplyEmailData({ ...replyEmailData, email_body: "" });
  }

  return (
    <>
      {
        fetchedUsersDataState && emailData ?
          <div className="rightpage_container">
            <div className="rightpage_headerbox">
              <FontAwesomeIcon icon={faStar} className="icons" />
              <FontAwesomeIcon icon={faPrint} className="icons" />
              <FontAwesomeIcon icon={faTrash} className="icons" />
              <FontAwesomeIcon icon={faEllipsisVertical} className="icons" />
            </div>

            <div className="parent_mail_container">
              <div className="time_container">
                <span className='meeting_card_time'>{formatDate(emailData.timestamp)}</span>
              </div>
              <div className="mail_title">
                <span>{emailData.subject}</span>
              </div>


              <div className={`mail_container ${mailCardState}`} >
                <div className="mail_sender mail_card" onClick={handleMailCardClick}>
                  <div className="mail_profile">
                    <img src={fetchedUsersDataState.profileImage_path || userLogo} alt="profile_image" height="40px" width="40px" className="profileLogo" />
                    {/* <FontAwesomeIcon icon={faReply} className="icons" /> */}
                  </div>
                  <div className='message_container'>
                    <div className="mail_sender_details">
                      <span className='mail_name'>{fetchedUsersDataState.displayName}</span>
                      <span className='mail_email'>{fetchedUsersDataState.email}</span>
                    </div>
                    <span className='mail_message'> - {emailData.email_body && emailData.email_body.length > 35 ? emailData.email_body.slice(0, 35) + `...` : emailData.email_body}</span>
                    <span className="mail_time">{formatDate(emailData.timestamp)}</span>
                  </div>
                </div>
                <div className="mail_body">
                  {emailData.email_body}
                </div>
              </div>

              <div className="reply_mail_container">
                <textarea className="replyMail_box" placeholder="Write your mail" onChange={inputEvent} name="email_body" value={replyEmailData.email_body}></textarea>
              </div>
              <div className="text_design_container">
                <button><FontAwesomeIcon icon={faB} className="icons" /></button>
                <button><FontAwesomeIcon icon={faItalic} className="icons" /></button>
                <button><FontAwesomeIcon icon={faUnderline} className="icons" /></button>
                <button><FontAwesomeIcon icon={faPaperclip} className="icons" /></button>
                <button><FontAwesomeIcon icon={faImage} className="icons" /></button>
                <button><FontAwesomeIcon icon={faTrash} className="icons" /></button>
              </div>
              <div className="sendButton_container">
                <button onClick={handleReplyEmailSend}>
                  <span>Send</span>
                  <FontAwesomeIcon icon={faPaperPlane} className="icons" />
                </button>
              </div>
            </div>
          </div> :
          <LoadingPage />
      }

    </>
  );
};

export default Rightpage;
